import React, {useState, useEffect, useRef} from 'react';
import WeekName from './WeekName.js';
import {blue, green, purple} from "@material-ui/core/colors";
import {makeStyles} from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import clsx from 'clsx';
import right from '../../assets/images/right3.png';
import left from '../../assets/images/left3.png';
import CalendarItem from './CalendarItem0.js' ;
import {getcalendar0, reservedate, pricedate, deletereserve, reservedetails} from '../../api/api.js'
import "./calendar.css";
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button'
import {useDispatch, useSelector} from "react-redux";
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

import DialogClose from '../../../src/util/DialogClose.js';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import Checkbox from '@material-ui/core/Checkbox';
import {
    saveUpdate
} from 'actions/Auth';

var moment = require('moment-jalaali')
var persian = require('persian-date');


const useStyles = makeStyles((theme) => ({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },

        '&.MuiIconButton-root': {

            padding: 2,

        },


    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },

    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    red: {

        color: '#f44336',


    },

    underlinetext: {

        fontSize: '0.75rem',
        marginTop: 5,
        color: '#f44336',
        fontFamily: 'iransans',


    },


    borderred: {
        fontFamily: 'iransans',
        border: '1px solid #f44336',
        borderRadius: 4,
        fontSize: 5,


    },
    border: {
        fontFamily: 'iransans',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 10,
        fontSize: 5,
        marginBottom: 0,
        color: 'rgba(0, 0, 0, 0.54)',


        "&:hover": {
            cursor: 'pointer'
        },


    },

    borderselected: {
        fontFamily: 'iransans',
        border: '1px solid #152e84',
        borderRadius: 10,
        fontSize: 5,
        backgroundColor: '#152e84',
        marginBottom: 0,
        color: 'rgba(0, 0, 0, 0.54)',

        "&:hover": {
            cursor: 'pointer'
        },

    },


    paper: {
        width: '80%',
        maxHeight: 435,
    },

    sendpic: {
        margin: '0 auto',
        marginBottom: 15,
        textAlign: 'center',
        '&:hover': {
            cursor: 'pointer',
        },
    },

    button: {
        fontSize: 18,
        fontWeight: 'bold',
        height: 43,
        width: '100%',
        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: '#3f51b5',
        '&:hover': {
            backgroundColor: '#172b95',
        },
    },

    input2: {
        fontFamily: 'iransans',
        width: '100%'
    },
    input: {
        fontFamily: 'iransans',
        width: '100%',
        marginTop: 15
    },
    formControl: {
        fontFamily: 'iransans',
        width: '100%',
        marginBottom: 15,

    },

    wrapper: {
        marginTop: 15,
        position: 'relative',
    },
    buttonSuccess: {
        fontSize: 18,
        fontWeight: 'bold',
        height: 43,
        width: '100%',

        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },

    buttonProgress2: {
        color: green[500],
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },


    iconButton: {
        padding: 10,
        fontSize: 15,
        fontFamily: 'iransans'
    },
    divider: {
        height: 28,
        margin: 4,
    },

    direction: {
        direction: 'rtl',
        width: 150,
        height: 40
    },

    fontright: {
        fontFamily: 'iransans',
        textAlign: 'right',
        marginRight: 10,
        width: 100
    },
    fontleft: {
        fontFamily: 'iransans',
        textAlign: 'right',
        marginLeft: 10
    }

    ,
    center: {

        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'

    },
    margin: {

        width: 50,
        height: 25,
        textAlign: 'center'


    },
    textBox: {
        "& $div": {
            justifyContent: "center",
            "& $input": {
                width: "30%"
            }
        },
        "& $p": {
            alignSelf: "center"
        }
    },
    inputremove: {

        textAlign: 'center',


        '&:focus': {
            backgroundColor: 'transparent',
            outline: 'none'
        },


    }


}));

function persianToEnglish(value) {
    var newValue = "";
    for (var i = 0; i < value.length; i++) {
        var ch = value.charCodeAt(i);
        if (ch >= 1776 && ch <= 1785) // For Persian digits.
        {
            var newChar = ch - 1728;
            newValue = newValue + String.fromCharCode(newChar);
        } else if (ch >= 1632 && ch <= 1641) // For Arabic & Unix digits.
        {
            var newChar = ch - 1584;
            newValue = newValue + String.fromCharCode(newChar);
        } else
            newValue = newValue + String.fromCharCode(ch);
    }
    return newValue;
};


var list;
let reserve = [];
let noreserve = [];
let noreserve2 = [];
let reservemain = [];
let pricelist = [];
let start = "";
let end = "";
let price = "";
let addprice = "";
let single = true;
let today;
let startmonth;


function toPersianNum(num, dontTrim) {

    var i = 0,

        dontTrim = dontTrim || false,

        num = dontTrim ? num.toString() : num.toString().trim(),
        len = num.length,

        res = '',
        pos,

        persianNumbers = typeof persianNumber == 'undefined' ?
            ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] :
            persianNumbers;

    for (; i < len; i++)
        if ((pos = persianNumbers[num.charAt(i)]))
            res += pos;
        else
            res += num.charAt(i);

    return res;
};

function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)}/>}
            icon={<span className={classes.icon}/>}
            {...props}
        />
    );
}

const MySwal = withReactContent(Swal);
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})
const Calendar = (props) => {

    const classes = useStyles();
    const [changeprice, setChangeprice] = React.useState(props.typecalendar);
    const [value, setValue] = React.useState('تک روز');
    const [cal, setCal] = useState(new persian());
    const [show, setShow] = useState(false);
    const [render, setRender] = useState(true);
    const [days, setDays] = useState([]);
    const [disable, setDisable] = useState(false);
    const [loader, setLoader] = useState(false);
    const [loaderedit, setLoaderedit] = useState(false);
    const [loaderdeleteone, setLoaderdeleteone] = useState(false);
    const [loaderdelete, setLoaderdelete] = useState(false);
    const [reserveid, setReserveid] = useState(0);
    const [idrangereserve, setIdrangereserve] = useState(0);
    const [opendescription, setOpendescription] = useState(false);
    const [openalert, setOpenalert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [description, setDescription] = useState('');
    const [prices, setPrices] = useState('');
    const [addprices, setaddprices] = useState('');
    const [selecteddate, setSelecteddate] = useState('');
    const [loaderereserve, setLoaderereserve] = useState(false);
    const [dialogclose, setDialogclose] = React.useState(false);
    const [loaderclose, setLoaderclose] = React.useState(false);
    const [deleteone, setDeleteone] = React.useState(false);
    const [checkupdate, setCheckupdate] = React.useState(false);
    const {update} = useSelector(({auth}) => auth);
    const dispatch = useDispatch();
    // const [start, setStart] = useState('');
    // const [end, setEnd] = useState('');

    debugger;

    const handleChange = (event) => {
        debugger;

        setValue(event.target.value);
        debugger;
        if (event.target.value === 'تک روز') {
            single = true;

        } else {
            debugger;
            single = false;

        }


    };
    const clickchangeprice = () => {
        // if (changeprice) {
        //     setChangeprice(false);
        // } else {
        //     setChangeprice(true);
        // }

        start = "";
        end = "";
        setLoader(false);
        reserve.length = 0;
        pricelist.length = 0;
        noreserve.length = 0;
        setChangeprice(!changeprice);
        // setRender(!render)


    };
    const clickreserve = () => {
        // if (changeprice) {
        //     setChangeprice(false);
        // } else {
        //     setChangeprice(true);
        // }
        setLoader(false);
        start = "";
        end = "";
        reserve.length = 0;
        pricelist.length = 0;
        setChangeprice(!changeprice);
        // setRender(!render)

    };

    const clickpreviousmonth = () => {

        setShow(false);

        setCal(new persian(cal.subtract('months', 1)))

        // getcalendar(persianToEnglish(cal.format('YYYY') + '/' + persianToEnglish(cal.format('MM'))));


    };


    useEffect(() => {

        getcalendar(persianToEnglish(cal.format('YYYY') + '/' + persianToEnglish(cal.format('MM'))), props.homeid);

    }, [cal]);

    const clicknextmonth = () => {
        setShow(false);

        setCal(new persian(cal.add('months', 1)))


    };


    const getcalendar = (date, homeid) => {


        getcalendar0(date, homeid, false, 0)
            .then((response) => {
                // console.log(response.data)
                // const json = JSON.parse(response.data)
                // const dates = Object.keys(json['CalendarData'])
                // console.log(json.CalendarData)
                reservemain.length = 0;
                noreserve.length = 0;
                noreserve2.length = 0;
                debugger;
                list = response.data.CalendarData;
                setShow(true);
                //drawmonth();

            })
            .catch((error) => {
                debugger;
                console.log(error)
            })


    };


    const on_mouse_over = () => {

        if (start !== "" && end === "") {


        }
    };


    const addselected = (date, georgiandate, type) => {
        // alert('We pass argument from Child to Parent: ' + date);


        debugger;

        if (changeprice) {

            // alert(changeprice);

            if (!single) {


                if (type === 2) {


                    if (pricelist.includes(date)) {
                        var index = pricelist.indexOf(date);
                        pricelist.splice(index, 1);
                        //reserve.push(date);
                    } else {
                        pricelist.push(date);
                    }

                    setRender(!render);


                } else {


                    debugger;
                    if (start !== "" && end !== "") {

                        start = "";
                        end = "";
                        // setStart(georgiandate)
                    }


                    if (start !== "" && end === "") {

                        // setShow(false);


                        end = date;
                        // setEnd(georgiandate)


                        var arr = start.split('/');
                        var brr = end.split('/');

                        console.log('date: ', arr[0]);
                        console.log('month: ', arr[1]);
                        console.log('year: ', arr[2]);

                        var a = new persian([parseInt(arr[0]), parseInt(arr[1]), parseInt(arr[2])]);
                        var b = new persian([parseInt(brr[0]), parseInt(brr[1]), parseInt(brr[2])]);
                        var dif = b.diff(a, 'days');

                        let s = b.diff(a);

                        debugger;

                        if (s < 0) {

                            var index = pricelist.indexOf(start);
                            pricelist.splice(index, 1);

                            end = "";
                            start = "";
                            start = date;
                            if (pricelist.includes(start)) {

                            } else {
                                pricelist.push(start);
                            }
                            debugger;


                        } else if (s === 0) {


                        } else {
                            var i;
                            for (i = 0; i < dif + 1; i++) {

                                var x = a.add('days', i)
                                var mytoday = persianToEnglish(x.format('D'));
                                var mymonth = persianToEnglish(x.format('MM'));
                                var myyear = persianToEnglish(x.format('YYYY'));
                                var date = myyear + '/' + mymonth + '/' + mytoday;


                                if (pricelist.includes(date)) {
                                    // var index = reserve.indexOf(date);
                                    // reserve.splice(index, 1);
                                    //reserve.push(date);
                                } else {
                                    pricelist.push(date);
                                }

                                debugger;
                            }


                        }


                        debugger;
                        // drawmonth();


                        // var delayInMilliseconds = 2000; //1 second
                        //
                        // setTimeout(function () {
                        setRender(!render);
                        //     //your code to be executed after 1 second
                        // }, delayInMilliseconds);


                    }


                    if (start === "" && end === "") {

                        start = date;
                        if (pricelist.includes(date)) {
                            var index = pricelist.indexOf(date);
                            pricelist.splice(index, 1);
                            //reserve.push(date);
                        } else {
                            pricelist.push(date);
                        }
                        setRender(!render);

                        // setStart(georgiandate)
                    }


                }


            } else {

                if (pricelist.includes(date)) {
                    var index = pricelist.indexOf(date);
                    pricelist.splice(index, 1);
                    //reserve.push(date);
                } else {
                    pricelist.push(date);
                }

                setRender(!render);


            }
        } else {

            //alert(changeprice);


            if (!single) {


                if (type === 2) {


                    if (noreserve.includes(date)) {
                        var index = noreserve.indexOf(date);
                        noreserve.splice(index, 1);
                        //reserve.push(date);
                    } else {

                    }


                    if (reserve.includes(date)) {
                        var index = reserve.indexOf(date);
                        reserve.splice(index, 1);
                        //reserve.push(date);
                    } else {
                        reserve.push(date);
                    }
                    // alert(reserve);
                    setRender(!render);


                } else {
                    debugger;
                    // alert(start);
                    // alert(end);
                    if (start !== "" && end !== "") {

                        start = "";
                        end = "";
                        // setStart(georgiandate)
                    }


                    if (start !== "" && end === "") {

                        // setShow(false);


                        end = date;
                        // setEnd(georgiandate)


                        var arr = start.split('/');
                        var brr = end.split('/');

                        console.log('date: ', arr[0]);
                        console.log('month: ', arr[1]);
                        console.log('year: ', arr[2]);

                        var a = new persian([parseInt(arr[0]), parseInt(arr[1]), parseInt(arr[2])]);
                        var b = new persian([parseInt(brr[0]), parseInt(brr[1]), parseInt(brr[2])]);
                        var dif = b.diff(a, 'days');


                        var i;
                        for (i = 0; i < dif + 1; i++) {

                            var x = a.add('days', i)
                            var mytoday = persianToEnglish(x.format('D'));
                            var mymonth = persianToEnglish(x.format('MM'));
                            var myyear = persianToEnglish(x.format('YYYY'));
                            var date = myyear + '/' + mymonth + '/' + mytoday;


                            if (noreserve.includes(date)) {
                                var index = noreserve.indexOf(date);
                                noreserve.splice(index, 1);
                                //reserve.push(date);
                            } else {

                            }


                            if (reserve.includes(date)) {
                                // var index = reserve.indexOf(date);
                                // reserve.splice(index, 1);
                                //reserve.push(date);
                            } else {
                                reserve.push(date);
                            }

                            debugger;
                        }

                        debugger;
                        // drawmonth();


                        // var delayInMilliseconds = 2000; //1 second
                        //
                        // setTimeout(function () {
                        setRender(!render);
                        //     //your code to be executed after 1 second
                        // }, delayInMilliseconds);


                    }


                    if (start === "" && end === "") {

                        start = date;
                        if (reserve.includes(date)) {
                            var index = reserve.indexOf(date);
                            reserve.splice(index, 1);
                            //reserve.push(date);
                        } else {
                            reserve.push(date);
                        }
                        // alert(reserve);
                        setRender(!render);

                        // setStart(georgiandate)
                    }


                }


            } else {

                // alert(type)
                if (noreserve.includes(date)) {
                    var index = noreserve.indexOf(date);
                    noreserve.splice(index, 1);
                    // alert('yek');
                    //reserve.push(date);-
                } else {
                    // alert('x');
                }
                //x se
                //

                if (reserve.includes(date)) {
                    var index = reserve.indexOf(date);
                    reserve.splice(index, 1);
                    //    alert('do');
                    //reserve.push(date);
                } else {
                    reserve.push(date);
                    // alert('se');
                }


                // alert(reserve);
                // alert(noreserve);
                // alert(reservemain);

                setRender(!render);


                // var delayInMilliseconds = 2000; //1 second
                //
                // setTimeout(function () {
                //     // alert('delay');
                //    setRender(!render);
                // }, delayInMilliseconds);


            }


        }


    };


    const selectreserved = (date) => {


        if (reservemain.includes(date)) {
            var index = reservemain.indexOf(date);
            reservemain.splice(index, 1);
            //reserve.push(date);
        } else {

        }


        if (noreserve.includes(date)) {
            var index = noreserve.indexOf(date);
            noreserve.splice(index, 1);
            //reserve.push(date);
        } else {
            noreserve.push(date);
        }
        // alert(date);
        // alert(noreserve);
        // alert(reservemain);
        // alert('y');
        setRender(!render);


    };


    const showdes = (id, date) => {

        setOpendescription(true);
        setReserveid(id);
        setSelecteddate(date);
        // alert(date);
        setIdrangereserve(id);


        reservedetails(id)
            .then((response) => {
                if (response.data.errorCode === 0) {


                    debugger;
                    console.log(response.data)

                    let des = 'این تاریخ مربوط به رزرو بازه ای ملک ' + response.data.Details.name + ' که توسط ' + response.data.Details.contactt + ' از تاریخ ' + toPersianNum(response.data.Details.startdate) + ' تا ' + toPersianNum(response.data.Details.enddate) + ' می باشد '

                    // alert(des);

                    setDescription(des);

                    setLoaderereserve(true);


                    //
                    // setHomename(response.data.Details.name);
                    // setStartdate(response.data.Details.startdate);
                    // setEnddate(response.data.Details.enddate);
                    // setGuestname(response.data.Details.contactt);
                    // setTasviename(response.data.Details.tasviename);
                    // HomeId = response.data.Details.idhome;
                    // GuestId = response.data.Details.idguest;
                    // TasvieId = response.data.Details.idtasvie;
                    // id = response.data.Details.id;


                }

            })
            .catch((error) => {


            })


    };


    useEffect(() => {
        // alert('sad');

        today = persianToEnglish(cal.format('YYYY/MM/D'));


        debugger;


        // getcalendar0(persianToEnglish(cal.format('YYYY') + '/' + persianToEnglish(cal.format('MM'))))
        //     .then((response) => {
        //
        //
        //         debugger;
        //         console.log(response.data)
        //         // const json = JSON.parse(response.data)
        //         // const dates = Object.keys(json['CalendarData'])
        //         // console.log(json.CalendarData)
        //         list = response.data.CalendarData;
        //         // drawmonth();
        //         setShow(true)
        //         drawmonth();
        //         debugger;
        //
        //     })
        //     .catch((error) => {
        //
        //         console.log(error)
        //         debugger;
        //     })


        return () => {
            // Anything in here is fired on component unmount.

            reserve.length = 0;
            reservemain.length = 0;
            start = "";
            end = "";
            single = true;
            list.length = 0;
            pricelist.length = 0;


        }


    }, []);


    const drawmonth = () => {

        // alert('render');
        // alert(reservemain);
        var mytoday = cal.format('DD');
        var mymonth = persianToEnglish(cal.format('MM'));
        var myyear = persianToEnglish(cal.format('YYYY'));

        let blanks = [];
        debugger;
        for (let i = 1; i < new persian([myyear, mymonth, 1]).days(); i++) {
            blanks.push(
                <td className="calendar-day empty">{""}</td>
            );
        }
        let daysInMonth = [];
        // if (mymonth === startmonth) {
        //     console.log('ast');
        //
        //     for (let d = 1; d <= list.length; d++) {
        //         if (list[d - 1].Day < persianToEnglish(mytoday)) {
        //             daysInMonth.push(
        //                 <td key={d}>
        //                     <CalendarItem month={mymonth} type={1} year={myyear} list={list[d - 1]} disable={true}
        //                                   handleToUpdate={addselected}/>
        //                 </td>
        //             );
        //         } else {
        //             daysInMonth.push(
        //                 <td key={d}>
        //                     <CalendarItem month={mymonth} type={1} year={myyear} list={list[d - 1]} disable={false}
        //                                   handleToUpdate={addselected}/>
        //                 </td>
        //             );
        //         }
        //     }
        // } else {
        //     console.log('nist');
        //     for (let d = 1; d <= list.length; d++) {
        //         daysInMonth.push(
        //             <td key={d}>
        //                 <CalendarItem month={mymonth} type={1} year={myyear} list={list[d - 1]}  disable={false}
        //                               handleToUpdate={addselected}/>
        //             </td>
        //         );
        //     }
        // }
        debugger;
        for (let d = 1; d <= list.length; d++) {
            var date = myyear + '/' + mymonth + '/' + d;

            if (changeprice) {


            } else {

                if (list[d - 1].Reserved && !noreserve.includes(date) && !reserve.includes(date) && !noreserve2.includes(date)) {
                    if (reservemain.includes(date)) {

                    } else {

                        // if(deleteone){
                        //
                        // }else {
                        //     reservemain.push(date);
                        //     setDeleteone(false);
                        // }

                        if (selecteddate === date) {

                        } else {

                            reservemain.push(date);

                        }


                    }

                } else {


                }

            }


            var arr = today.split('/');
            var brr = date.split('/');

            // console.log('date: ', arr[0]);
            // console.log('month: ', arr[1]);
            // console.log('year: ', arr[2]);

            var a = new persian([parseInt(arr[0]), parseInt(arr[1]), parseInt(arr[2])]);
            var b = new persian([parseInt(brr[0]), parseInt(brr[1]), parseInt(brr[2])]);

            let s = b.diff(a);


            if (changeprice) {

                if (s < 0) {

                    daysInMonth.push(
                        <td>
                            <CalendarItem month={mymonth} type={0} year={myyear} list={list[d - 1]} disable={true}
                                          handleToUpdate={addselected}/>
                        </td>
                    );


                } else if (s === 0) {


                    if (pricelist.includes(date)) {
                        daysInMonth.push(
                            <td>
                                <CalendarItem month={mymonth} type={2} year={myyear} list={list[d - 1]} disable={false}
                                              handleToUpdate={addselected} hover={on_mouse_over} showdes={showdes}/>
                            </td>
                        );

                    } else {

                        daysInMonth.push(
                            <td>
                                <CalendarItem month={mymonth} type={1} year={myyear} list={list[d - 1]} disable={false}
                                              handleToUpdate={addselected} hover={on_mouse_over} showdes={showdes}/>
                            </td>
                        );
                    }


                } else {


                    if (pricelist.includes(date)) {

                        daysInMonth.push(
                            <td>
                                <CalendarItem month={mymonth} type={2} year={myyear} list={list[d - 1]} disable={false}
                                              handleToUpdate={addselected} hover={on_mouse_over} showdes={showdes}/>
                            </td>
                        );


                    } else {
                        daysInMonth.push(
                            <td>
                                <CalendarItem month={mymonth} type={1} year={myyear} list={list[d - 1]} disable={false}
                                              handleToUpdate={addselected} hover={on_mouse_over} showdes={showdes}/>
                            </td>
                        );
                    }

                }


            } else {

                if (s < 0) {

                    daysInMonth.push(
                        <td>
                            <CalendarItem month={mymonth} type={0} year={myyear} list={list[d - 1]} disable={true}
                                          handleToUpdate={addselected}/>
                        </td>
                    );


                } else if (s === 0) {


                    if (reservemain.includes(date)) {
                        daysInMonth.push(
                            <td>
                                <CalendarItem month={mymonth} type={3} year={myyear} list={list[d - 1]} disable={false}
                                              handleToUpdate={addselected} selectreserved={selectreserved}
                                              hover={on_mouse_over} showdes={showdes}/>
                            </td>
                        );


                    } else if (reserve.includes(date)) {
                        daysInMonth.push(
                            <td>
                                <CalendarItem month={mymonth} type={2} year={myyear} list={list[d - 1]} disable={false}
                                              handleToUpdate={addselected} selectreserved={selectreserved}
                                              hover={on_mouse_over} showdes={showdes}/>
                            </td>
                        );

                    } else {

                        daysInMonth.push(
                            <td>
                                <CalendarItem month={mymonth} type={1} year={myyear} list={list[d - 1]} disable={false}
                                              handleToUpdate={addselected} selectreserved={selectreserved}
                                              hover={on_mouse_over} showdes={showdes}/>
                            </td>
                        );
                    }


                } else {


                    if (reservemain.includes(date)) {
                        daysInMonth.push(
                            <td>
                                <CalendarItem month={mymonth} type={3} year={myyear} list={list[d - 1]} disable={false}
                                              handleToUpdate={addselected} selectreserved={selectreserved}
                                              hover={on_mouse_over} showdes={showdes}/>
                            </td>
                        );
                    } else if (reserve.includes(date)) {
                        // alert(date);
                        daysInMonth.push(
                            <td>
                                <CalendarItem month={mymonth} type={2} year={myyear} list={list[d - 1]} disable={false}
                                              handleToUpdate={addselected} selectreserved={selectreserved}
                                              hover={on_mouse_over} showdes={showdes}/>
                            </td>
                        );


                    } else {
                        daysInMonth.push(
                            <td>
                                <CalendarItem month={mymonth} type={1} year={myyear} list={list[d - 1]} disable={false}
                                              handleToUpdate={addselected} selectreserved={selectreserved}
                                              hover={on_mouse_over} showdes={showdes}/>
                            </td>
                        );
                    }

                }


            }
        }
        var totalSlots = [...blanks, ...daysInMonth];
        let rows = [];
        let cells = [];
        totalSlots.forEach((row, i) => {
            if (i % 7 !== 0) {
                cells.push(row); // if index not equal 7 that means not go to next week
            } else {
                rows.push(cells); // when reach next week we contain all td in last week to rows
                cells = []; // empty container
                cells.push(row); // in current loop we still push current row to new container
            }
            if (i === totalSlots.length - 1) { // when end loop we add remain date
                rows.push(cells);
            }
        });

        var daysinmonth = null;
        daysinmonth = rows.map((d, i) => {
            return <tr>{d}</tr>;
        });
        // setDays(daysinmonth);

        // console.log(daysinmonth)
        // debugger
        return daysinmonth;


    };


    const savechangeprice = () => {


        if (price !== "" && addprice !== "") {

            var delayInMilliseconds = 100; //1 second
            // setTimeout(function () {
            //     let h = list;
            //     debugger;
            //     for (let i = 0; i <= pricelist.length - 1; i++) {
            //         let s = pricelist[i];
            //         debugger;
            //         var arr = s.split('/');
            //         debugger;
            //         console.log('date: ', arr[0]);
            //         console.log('month: ', arr[1]);
            //         console.log('year: ', arr[2]);
            //         list[parseInt(arr[2]) - 1].Price = price;
            //         list[parseInt(arr[2]) - 1].AddPrice = addprice;
            //     }
            //     pricelist.length = 0;
            //     setRender(!render);
            // }, delayInMilliseconds);


            if (pricelist.length === 0) {
                Toast.fire({
                    icon: 'error',
                    title: 'لطفا تاریخ مورد نظر را انتخاب کنید!'
                })
                return;
            }


            var listOfObjects = [];
            var a = ["car", "bike", "scooter"];
            pricelist.forEach(function (entry) {
                debugger
                var singleObj = {};
                singleObj['IsReserve'] = true;
                singleObj['Date'] = entry;
                listOfObjects.push(singleObj);
            });

            var myJsonString = JSON.stringify(pricelist);

            debugger;
            var body = new FormData();
            body.append('homeid', props.homeid);
            body.append('data', myJsonString);
            body.append('price', price);
            body.append('addedprice', addprice);

            setLoader(true);
            pricedate(body)
                .then((response) => {

                    // console.log(response.data)
                    // const json = JSON.parse(response.data)
                    // const dates = Object.keys(json['CalendarData'])
                    // console.log(json.CalendarData)
                    debugger;

                    for (let i = 0; i <= pricelist.length - 1; i++) {
                        let s = pricelist[i];
                        debugger;
                        var arr = s.split('/');
                        debugger;
                        // console.log('date: ', arr[0]);
                        // console.log('month: ', arr[1]);
                        // console.log('year: ', arr[2]);
                        list[parseInt(arr[2]) - 1].Price = price;
                        list[parseInt(arr[2]) - 1].AddPrice = addprice;
                    }
                    pricelist.length = 0;
                    setRender(!render);
                    setLoader(false);
                    setPrices('');
                    setaddprices('');
                    // MySwal.fire({
                    //         icon: 'success',
                    //         title: 'ثبت قیمت', showCancelButton: false,
                    //         showConfirmButton: true,
                    //         confirmButtonText: 'باشه',
                    //         text: 'تغییرات قیمت با موفقیت ثبت شد !',
                    //     });
                    Toast.fire({
                        icon: 'success',
                        title: 'تغییرات قیمت با موفقیت ثبت شد !'
                    })

                    let update0 = localStorage.getItem("update");
                    // alert(update0);
                    dispatch(saveUpdate(Number(update0) + 1));
                    localStorage.setItem("update", Number(update0) + 1);

                    if (checkupdate) {
                        setDialogclose(false);
                        props.openchecksiteprice(props.homeid, price, addprice);
                    } else {

                    }

                    //setLoader(false);


                    // for (let d = 0; d < pricelist.length; d++) {
                    //
                    //
                    //
                    //
                    //
                    //
                    //
                    // }


                    //drawmonth();

                })
                .catch((error) => {
                    debugger;
                    setLoader(false);
                    console.log(error)
                })


        } else {
            Toast.fire({
                icon: 'error',
                title: 'لطفا قیمت ها را وارد کنید !'
            })
        }
    };


    const savechangereserve = () => {


        debugger;

        if (reserve.length !== 0 || noreserve.length !== 0) {
            // var delayInMilliseconds = 500; //1 second
            // setTimeout(function () {
            //     let h = list;
            //     debugger;
            //     for (let i = 0; i <= reserve.length - 1; i++) {
            //
            //         if (reservemain.includes(reserve[i])) {
            //
            //         } else {
            //             reservemain.push(reserve[i]);
            //         }
            //
            //
            //         // let s = pricelist[i];
            //         // debugger;
            //         // var arr = s.split('/');
            //         // debugger;
            //         // console.log('date: ', arr[0]);
            //         // console.log('month: ', arr[1]);
            //         // console.log('year: ', arr[2]);
            //         // list[parseInt(arr[2]) - 1].Price = price;
            //         // list[parseInt(arr[2]) - 1].AddPrice = addprice;
            //     }
            //     reserve.length = 0;
            //     setRender(!render);
            // }, delayInMilliseconds);
            setLoader(true);

            var listOfObjects = [];
            var a = ["car", "bike", "scooter"];
            reserve.forEach(function (entry) {
                debugger
                var singleObj = {};
                singleObj['IsReserve'] = true;
                singleObj['Date'] = entry;
                listOfObjects.push(singleObj);
            });

            noreserve.forEach(function (entry) {
                debugger
                var singleObj = {};
                singleObj['IsReserve'] = false;
                singleObj['Date'] = entry;
                listOfObjects.push(singleObj);
            });


            var myJsonString = JSON.stringify(listOfObjects);

            debugger;
            var body = new FormData();
            body.append('homeid', props.homeid);
            body.append('data', myJsonString);


            reservedate(body)
                .then((response) => {


                    if (response.data.errorCode === 0) {
                        // alert(reserve);
                        // alert(noreserve);
                        // alert(reservemain);
                        reserve.forEach(function (entry) {
                            debugger
                            reservemain.push(entry);
                        });
                        noreserve.forEach(function (entry) {
                            debugger
                            noreserve2.push(entry);
                        });
                        reserve.length = 0;
                        noreserve.length = 0;
                        console.log('test');
                        console.log(reservemain);


                        setLoader(false);
                        setRender(!render);
                        setOpendescription(false);
                        // setAlertMessage('تغییرات رزرو با موفقیت ثبت شد !');
                        // setOpenalert(true);
                        // MySwal.fire('ثبت رزرو', 'تغییرات رزرو با موفقیت ثبت شد !', 'success');
                        // MySwal.fire({
                        //     icon: 'success',
                        //     title: 'ثبت رزرو', showCancelButton: false,
                        //     showConfirmButton: true,
                        //     confirmButtonText: 'باشه',
                        //     text: 'تغییرات رزرو با موفقیت ثبت شد !',
                        // });
                        Toast.fire({
                            icon: 'success',
                            title: 'تغییرات رزرو با موفقیت ثبت شد !'
                        })
                        // alert(update);
                        let update0 = localStorage.getItem("update");
                        // alert(update0);
                        dispatch(saveUpdate(Number(update0) + 1));
                        localStorage.setItem("update", Number(update0) + 1);

                        if (checkupdate) {
                            setDialogclose(false);
                            props.openchecksite(props.homeid);
                        } else {

                        }

                        deletereserve(idrangereserve)
                            .then((response) => {
                                if (response.data.errorCode === 0) {




                                }
                            })
                            .catch((error) => {
                                debugger;

                            });

                        // alert(reserve);
                        // alert(noreserve);
                        // alert(reservemain);


                    } else {

                    }


                    //drawmonth();

                })
                .catch((error) => {
                    debugger;

                    setLoader(false);

                })


        } else {
            Toast.fire({
                icon: 'error',
                title: 'لطفا روزها را انتخاب کنید !'
            })
        }


    };

    const editreserve = () => {


        props.toedit(reserveid);

    };


    const deleteonreserve = () => {
        setLoaderdeleteone(true)
        noreserve.push(selecteddate);


        var index = reservemain.indexOf(selecteddate);
        reservemain.splice(index, 1);

        setDeleteone(true);

        savechangereserve()


    };


    const onClickdeletereserve = () => {
        setDialogclose(true);

    };


    const onchangeprice = (e) => {

        price = e.target.value;
        setPrices(e.target.value);


    };

    const onchangeaddprice = (e) => {

        addprice = e.target.value;
        setaddprices(e.target.value);

    };


    const onClickdelete = () => {


    };

    const onClickyes = () => {


        setLoaderclose(true);
        setDialogclose(false);


        deletereserve(reserveid)
            .then((response) => {
                if (response.data.errorCode === 0) {

                    setLoaderclose(false);
                    setDialogclose(false);
                    setOpendescription(false);

                    setShow(false);

                    setCal(new persian(cal.add('minute', 30)))
                    setRender(!render)


                }
            })
            .catch((error) => {
                debugger;

            });


        // var delayInMilliseconds = 2000; //1 second
        //
        // setTimeout(function () {
        //     //your code to be executed after 1 second
        //     setLoader(false);
        //
        // }, delayInMilliseconds);


    };
    const onClickcancel = () => {

        setDialogclose(false);


    };


    return (

        <div className="d-flex flex-column" style={{width: '100%'}}>

            {/*<div className="d-flex flex-column" style={{fontFamily: 'iransans', fontSize: 10}}>*/}
            {/*<div>نوع ویرایش را انتخاب کنید:</div>*/}
            {/*{changeprice ?*/}
            {/*<div className="d-flex align-items-center" style={{marginTop: 10}}>*/}
            {/*<div onClick={clickchangeprice} className={classes.borderselected} style={{*/}
            {/*width: '100%',*/}
            {/*height: 25,*/}
            {/*marginLeft: 5,*/}
            {/*flex: 1,*/}
            {/*cursor: 'pointer',*/}
            {/*display: 'flex',*/}
            {/*flexDirection: 'column',*/}
            {/*justifyContent: 'center',*/}
            {/*alignItems: 'center'*/}
            {/*}}>*/}

            {/*<div style={{fontSize: 10, fontWeight: 'bold', color: '#fff'}}>تغییر قیمت ها</div>*/}


            {/*</div>*/}

            {/*<div onClick={clickreserve} className={classes.border} style={{*/}
            {/*width: '100%',*/}
            {/*height: 25,*/}
            {/*marginRight: 5,*/}
            {/*flex: 1,*/}
            {/*cursor: 'pointer',*/}
            {/*display: 'flex',*/}
            {/*flexDirection: 'column',*/}
            {/*justifyContent: 'center',*/}
            {/*alignItems: 'center'*/}
            {/*}}>*/}

            {/*<div style={{fontSize: 10, fontWeight: 'bold', color: '#000'}}>ثبت رزروهای شخصی</div>*/}

            {/*</div>*/}


            {/*</div>*/}

            {/*:*/}

            {/*<div className="d-flex align-items-center" style={{marginTop: 10}}>*/}


            {/*<div onClick={clickchangeprice} className={classes.border} style={{*/}
            {/*width: '100%',*/}
            {/*height: 25,*/}
            {/*marginLeft: 5,*/}
            {/*flex: 1,*/}
            {/*display: 'flex',*/}
            {/*cursor: 'pointer',*/}
            {/*flexDirection: 'column',*/}
            {/*justifyContent: 'center',*/}
            {/*alignItems: 'center'*/}
            {/*}}>*/}

            {/*<div style={{fontSize: 10, fontWeight: 'bold', color: '#000'}}>تغییر قیمت ها</div>*/}


            {/*</div>*/}

            {/*<div onClick={clickreserve} className={classes.borderselected} style={{*/}
            {/*width: '100%',*/}
            {/*height: 25,*/}
            {/*marginRight: 5,*/}
            {/*flex: 1,*/}
            {/*cursor: 'pointer',*/}
            {/*display: 'flex',*/}
            {/*flexDirection: 'column',*/}
            {/*justifyContent: 'center',*/}
            {/*alignItems: 'center'*/}
            {/*}}>*/}

            {/*<div style={{fontSize: 10, fontWeight: 'bold', color: '#fff'}}>ثبت رزروهای شخصی</div>*/}

            {/*</div>*/}


            {/*</div>*/}

            {/*}*/}


            {/*</div>*/}

            {/*<Divider style={{marginTop: 10}}>*/}
            {/*</Divider>*/}


            <Snackbar open={openalert} autoHideDuration={3000} onClose={() => setOpenalert(false)}>
                <Alert style={{fontFamily: 'iransans'}} severity="error">
                    {alertMessage}
                </Alert>
            </Snackbar>


            {/*<div className="d-flex align-items-center" style={{marginBottom: 10}}>*/}


            {/*    <div style={{marginTop: 10, fontFamily: 'iransans', fontSize: 12}}>*/}

            {/*        شیوه انتخاب روز:*/}

            {/*    </div>*/}


            {/*    <RadioGroup style={{marginTop: 10, marginRight: 20}} defaultValue="تک روز" name="customized-radios"*/}
            {/*                value={value} onChange={handleChange} row>*/}
            {/*        <FormControlLabel label={<div*/}
            {/*            style={{fontFamily: 'iransans', marginRight: 5, fontSize: 10, textAlign: 'center'}}>تک*/}
            {/*            روز</div>} value="تک روز" control={<StyledRadio/>}>*/}
            {/*        </FormControlLabel>*/}
            {/*        <FormControlLabel style={{marginRight: 2}} label={<div*/}
            {/*            style={{fontFamily: 'iransans', marginRight: 5, fontSize: 10, textAlign: 'center'}}>بازه*/}
            {/*            ای</div>} value="بازه ای" control={<StyledRadio/>}>*/}
            {/*        </FormControlLabel>*/}
            {/*    </RadioGroup>*/}


            {/*</div>*/}
            {changeprice ?
                <div
                    style={{marginRight: 3, marginTop: 9, marginBottom: 9, fontFamily: 'iransans', fontWeight: 'bold'}}>
                    لطفا روزهایی که می خواهید تغییر قیمت بدین را انتخاب کنید
                </div>
                :
                <div
                    style={{marginRight: 3, marginTop: 9, marginBottom: 9, fontFamily: 'iransans', fontWeight: 'bold'}}>
                    لطفا روزهایی که می خواهید باز کنید یا ببندید را انتخاب کنید
                </div>
            }


            <div className="d-flex align-items-center" style={{marginBottom: 10}}>

                <div onClick={clickpreviousmonth} style={{flex: 1, cursor: 'pointer'}}>
                    <img src={right} style={{width: 20, height: 20}}></img>

                </div>

                <div style={{
                    fontFamily: 'iransans',
                    fontSize: 15,
                    fontWeight: 'bold',
                    textAlign: 'center',
                    flex: 1,
                    color: '#000',
                    marginHorizontal: 20,
                    flexGrow: 1
                }}>

                    {cal.format('MMMM')}


                </div>

                <div onClick={clicknextmonth} style={{flex: 1, textAlign: 'left', cursor: 'pointer'}}>
                    <img src={left} style={{width: 20, height: 20}}></img>
                </div>


            </div>


            <WeekName/>

            {/*{show ?*/}
            {/*<CalendarMain Dayweek={dayweek}  list={list}  />*/}


            {/*:*/}

            {/*null*/}


            {/*}*/}

            {show ?

                <div style={{width: 'inherit', marginTop: 5}}>
                    {/*{render ?*/}

                    {/*    <table className="calendar-day" style={{width: 'inherit', marginTop: 5}}>*/}
                    {/*        <tbody>{drawmonth()}</tbody>*/}
                    {/*    </table> :*/}
                    {/*    <table className="calendar-day" style={{width: 'inherit', marginTop: 5}}>*/}
                    {/*        <tbody>{drawmonth()}</tbody>*/}
                    {/*    </table>*/}


                    {/*}*/}
                    <table className="calendar-day" style={{width: 'inherit', marginTop: 5}}>
                        <tbody>{drawmonth()}</tbody>
                    </table>


                </div>


                :
                <div style={{
                    height: 250, display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>

                    <CircularProgress size={24} className={classes.buttonProgress2}/>
                </div>
            }

            {changeprice ?
                <div style={{marginTop: 15, display: 'flex', alignItems: 'center'}}>
                    <Checkbox style={{padding: 0}} checked={checkupdate}
                              onChange={e => setCheckupdate(e.target.checked)}/>
                    <div style={{marginRight: 3, fontFamily: 'iransans', fontWeight: 'bold'}}>مایل به آپدیت رزرو ها در
                        سایت
                        های همکار هستم
                    </div>
                </div>
                :
                <div style={{marginTop: 15, display: 'flex', alignItems: 'center'}}>
                    <Checkbox style={{padding: 0}} checked={checkupdate}
                              onChange={e => setCheckupdate(e.target.checked)}/>
                    <div style={{marginRight: 3, fontFamily: 'iransans', fontWeight: 'bold'}}>مایل به آپدیت رزرو ها در
                        سایت
                        های همکار هستم
                    </div>
                </div>
            }


            {changeprice ?
                <div>

                    <div className="d-flex align-items-center">


                        <div className={classes.border} style={{
                            width: 200,
                            height: 50,
                            marginLeft: 5, marginTop: 5,
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>

                            <div style={{flex: 1, textAlign: 'left', fontSize: 14}}>
                                قیمت جدید
                            </div>


                            {/*<div className="d-flex align-items-center" style={{*/}
                            {/*fontFamily: 'iransans',*/}
                            {/*fontSize: 10,*/}
                            {/*textAlign: 'center',*/}
                            {/*marginHorizontal: 20,*/}
                            {/*flexGrow: 1*/}
                            {/*}}>*/}

                            {/*<InputBase*/}
                            {/*className={classes.margin}*/}
                            {/*placeholder="مبلغ"*/}
                            {/*inputProps={{'aria-label': 'naked'}}*/}

                            {/*/>*/}


                            {/*</div>*/}


                            <div style={{
                                fontFamily: 'iransans',
                                fontSize: 10,
                                textAlign: 'center',
                                flex: 1,
                                marginHorizontal: 20,
                                flexGrow: 1
                            }}>


                                <input className={classes.inputremove} style={{
                                    border: 'none !important',
                                    backgroundColor: '#fff',
                                    borderWidth: 0, fontSize: 17,
                                    boxShadow: 'none'
                                }} placeholder="مبلغ" value={prices} onChange={e => onchangeprice(e)}>


                                </input>


                            </div>


                            {/*<TextField*/}
                            {/*style={{*/}
                            {/*fontFamily: 'iransans',*/}
                            {/*fontSize: 10,*/}
                            {/*textAlign: 'center',*/}
                            {/*flex: 1,*/}
                            {/*marginHorizontal: 20,*/}
                            {/*flexGrow: 1*/}
                            {/*}}*/}
                            {/*id="outlined-number"*/}
                            {/*InputProps={{*/}
                            {/*classes: {*/}
                            {/*root: classes.direction*/}
                            {/*},*/}
                            {/*}}*/}
                            {/*type="number"*/}
                            {/*InputLabelProps={{*/}
                            {/*shrink: false,*/}
                            {/*}}*/}
                            {/*variant="outlined"*/}
                            {/*/>*/}


                            {/*<div style={{*/}
                            {/*fontFamily: 'iransans',*/}
                            {/*fontSize: 10,*/}
                            {/*textAlign: 'center',*/}
                            {/*flex: 1,*/}
                            {/*marginHorizontal: 20,*/}
                            {/*flexGrow: 1*/}
                            {/*}}>*/}

                            {/*بهمن*/}


                            {/*</div>*/}

                            <div style={{flex: 1, textAlign: 'right', fontSize: 14}}>
                                هزار تومان
                            </div>


                        </div>


                    </div>


                    <div className="d-flex align-items-center">


                        <div className={classes.border} style={{
                            width: 200,
                            height: 50,
                            marginTop: 10,
                            marginLeft: 5,
                            flex: 1,
                            display: 'flex',

                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>

                            <div style={{flex: 1, textAlign: 'left', fontSize: 14}}>
                                قیمت نفر اضافه
                            </div>

                            <div style={{
                                fontFamily: 'iransans',
                                fontSize: 10,
                                textAlign: 'center',
                                flex: 1,
                                marginHorizontal: 20,
                                flexGrow: 1
                            }}>
                                <input className={classes.inputremove} style={{
                                    border: 'none !important',
                                    backgroundColor: '#fff',
                                    borderWidth: 0, fontSize: 17,
                                    boxShadow: 'none'
                                }} placeholder="مبلغ" value={addprices} onChange={e => onchangeaddprice(e)}>
                                </input>
                            </div>

                            <div style={{flex: 1, textAlign: 'right', fontSize: 14}}>
                                هزار تومان
                            </div>

                        </div>


                    </div>

                    <div className="d-flex align-items-center">

                        <Button onClick={savechangeprice} disabled={loader} variant="contained" color="primary" style={{
                            width: 200,
                            height: 50,
                            marginLeft: 5,
                            marginTop: 15,
                            marginBottom: 15,
                            cursor: 'pointer',
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            border: '1px solid ',
                            // backgroundColor: '#bb5eb4',
                            backgroundColor: '#152e84',
                            borderColor: '#152e84',
                            borderRadius: 10,
                        }} className="iran-font">
                            <div style={{fontSize: 15, color: '#fff', fontWeight: 'bold'}}>تغییر قیمت ها</div>
                            {loader &&
                            <CircularProgress size={24} className={classes.buttonProgress}/>}
                        </Button>
                    </div>
                </div>
                :
                <div className="d-flex align-items-center">
                    <Button onClick={savechangereserve} disabled={loader} variant="contained" color="primary" style={{
                        width: 200,
                        height: 50,
                        marginLeft: 5,
                        marginTop: 15,
                        marginBottom: 15,
                        cursor: 'pointer',
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: '1px solid ',
                        borderColor: '#152e84',
                        backgroundColor: '#152e84',
                        borderRadius: 10,
                    }}
                            className="iran-font">
                        <div style={{fontSize: 15, color: '#ffffff', fontWeight: 'bold'}}>ثبت رزرو ها</div>
                        {loader ?
                            <CircularProgress size={24} className={classes.buttonProgress}/>
                            : null
                        }
                    </Button>
                </div>
            }


            <Dialog open={opendescription} onClose={() => setOpendescription(false)}>

                <div style={{
                    display: 'flex', justifyContent: 'start',
                    alignItems: 'start', flexDirection: 'column'
                }}>


                    <div style={{
                        display: 'flex', justifyContent: 'space-between',
                        alignItems: 'center', width: '100%'
                    }}>

                        <div style={{
                            marginBottom: 10, marginTop: 10, fontSize: 15,
                            fontWeight: 'bold', marginRight: 10, fontFamily: 'iransans'
                        }}>
                            رزرو بازه ای
                        </div>

                        <IconButton onClick={() => setOpendescription(false)} aria-label="Close">
                            <CloseIcon/>
                        </IconButton>
                    </div>


                    <DialogContent>
                        <div style={{
                            width: '100%',
                            fontFamily: 'iransans',
                            fontSize: 15,
                            minHeight: 50,
                            fontWeight: 'bold'
                        }}>

                            {loaderereserve ?

                                description

                                :
                                <CircularProgress size={24} className={classes.buttonProgress}/>

                            }
                        </div>
                    </DialogContent>


                    <div style={{
                        display: 'flex', justifyContent: 'center', flexDirection: 'column',
                        paddingRight: 20, paddingLeft: 20, paddingBottom: 20,
                        alignItems: 'center', width: '100%', marginBottom: 20
                    }}>

                        <Button disabled={loaderedit} onClick={editreserve} variant="contained"
                                className="bg-primary text-white iran-font"
                                style={{width: '100%', marginTop: 5}}>
                            ویرایش رزرو

                            {loaderedit &&
                            <CircularProgress size={24} className={classes.buttonProgress}/>}

                        </Button>
                        {/*<Button disabled={loaderdelete} onClick={onClickdeletereserve} variant="contained"*/}
                        {/*        className="bg-primary text-white iran-font"*/}
                        {/*        style={{width: '100%', marginTop: 5}}>*/}
                        {/*    حذف رزرو*/}

                        {/*    {loaderdelete &&*/}
                        {/*    <CircularProgress size={24} className={classes.buttonProgress}/>}*/}

                        {/*</Button>*/}
                        <Button onClick={() => setOpendescription(false)} variant="contained"
                                className="bg-primary text-white iran-font"
                                style={{width: '100%', marginTop: 5}}>
                            انصراف
                        </Button>


                        <Button disabled={loaderdeleteone} onClick={deleteonreserve} variant="contained"
                                className="bg-red text-white iran-font"
                                style={{width: '100%', marginTop: 5}}>
                            فقط حذف روز {toPersianNum(selecteddate)}

                            {loaderdeleteone &&
                            <CircularProgress size={24} className={classes.buttonProgress}/>}

                        </Button>


                    </div>


                    {/*<div style={{overflow: 'hidden',flex:0.8}}>*/}
                    {/*<div style={{overflowY: 'scroll'}}>*/}


                    {/*</div>*/}
                    {/*</div>*/}


                </div>


            </Dialog>


            {dialogclose ?

                <DialogClose open={true} title='حذف رزرو' body='آیا از حذف این رزرو اطمینان دارید؟' loader={loader}
                             yes={onClickyes} cancel={onClickcancel}/>

                :

                <DialogClose open={false} title='حذف رزرو' body='آیا از حذف این رزرو اطمینان دارید؟' loader={loader}
                             yes={onClickyes} cancel={onClickcancel}/>


            }


        </div>


    );

};


export default Calendar;
